import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const FileInput = /*@__PURE__*/ proxyCustomElement(class FileInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.fileSelected = createEvent(this, "fileSelected", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.changeHandler = () => {
            const inputFileList = this.fileInput.files;
            if (inputFileList) {
                this.fileSelected.emit({
                    fileList: inputFileList,
                    document_type: this.documentType
                });
            }
        };
        this.files = undefined;
        this.fileString = undefined;
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.multiple = undefined;
        this.documentType = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    componentDidLoad() {
        this.fileInput = this.el.querySelector('input');
    }
    render() {
        return (h(Host, { key: 'e55c4e61544191f12bccce66ed922357090f6a12', exportparts: "label,input,input-invalid" }, h("div", { key: 'ec8dd08ef6d99ae26a82ff891b25ae2d3892aea1', class: "form-group d-flex flex-column" }, h("div", { key: '8430c4a605b4869e6bb4f206d5cbd1588c4e983d', class: "d-flex align-items-start gap-2" }, h("label", { key: 'e9519f7c08040964b5594961b6c26ce14bbc2681', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '67ec6c6453976e2e6442e82ab94f94a5d0d91bb2', helpText: this.helpText })), h("input", { key: 'a25d7f66085730bcb2a0f749f744f0f6bd9fa76e', ref: (el) => this.fileInput = el, type: "file", name: this.name, part: `input ${this.errorText ? "input-invalid " : ""}${this.disabled ? "input-disabled" : ""}`, class: this.errorText ? "form-control is-invalid" : "form-control", multiple: this.multiple, disabled: this.disabled, onChange: this.changeHandler, onInput: this.handleFormControlInput, onBlur: () => this.formControlBlur.emit() }), h("form-control-error-text", { key: '96b42ba795d86098932c1aeaf4d868cfce17895d', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
}, [0, "form-control-file", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "multiple": [4],
        "documentType": [1, "document-type"],
        "inputHandler": [16],
        "disabled": [4],
        "files": [32],
        "fileString": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-file", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-file":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, FileInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { FileInput as F, defineCustomElement as d };
